import { fetchReferralInfo } from '@/api/user'
import { fetchInvite } from '@/api/proxy'

const fetchTafData = async ({ commit, state, dispatch }, code, currency) => {
  try {
    const response = await fetchReferralInfo(code, currency)
    commit('SET_REFERRAL_DATA', response)
    if (!response.errors) {
    } else {
      throw response.errors
    }
  } catch (result) {
    throw result
  }
}

const loadTafData = async ({ dispatch, state }, code, currency) => {
  if (state.referralData === null) {
    await dispatch('fetchTafData', code, currency)
  }
}

const fetchTafInvite = async ({ commit, state, dispatch }, code, currency) => {
  try {
    const response = await fetchInvite(code, currency)
    commit('SET_TAF_INFO', response)
    if (!response.errors) {
    } else {
      throw response.errors
    }
  } catch (result) {
    throw result
  }
}

const loadTafInvite = async ({ dispatch, state }) => {
  if (state.tafInfo === null) {
    await dispatch('fetchTafInvite')
  }
}
export default {
  fetchTafInvite,
  fetchTafData,
  loadTafData,
  loadTafInvite
}



// WEBPACK FOOTER //
// ./src/store/modules/user/taf/actions.js